var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',{ref:"form",attrs:{"has-captcha":"send","items":_vm.data,"label-width":"2em","submit-text":"登 录"},on:{"update:items":function($event){_vm.data=$event},"submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }